exports.CERTFOCUS_ANALYTICS_PATH = '/certfocus/analytics';
exports.PREQUAL_ANALYTICS_PATH = '/prequal/analytics';